module.exports = __webpack_public_path__ + "static/media/YourStoryOurStory-social-1224x688px.697e743b.jpg";